export default __webpack_public_path__ + "static/media/IMG_1988.b7bf0afd.JPG";